import React from "react"
import { NOT_ENOUGH_DATA } from "@swipesense/compliance-helpers"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { nestedEntityPath } from "../../helpers/sharedHelperFunctions"
import { Progress } from "@swipesense/shared_components_v2/dist/index"
import { complianceAmount } from "../../helpers/sharedHelperFunctions"

export const ListItem = props => {
  const empty = props.compliance === NOT_ENOUGH_DATA

  return (
    <Link
      to={nestedEntityPath({
        parentEntityType: props.entityType,
        parentEntityId: props.entityId,
        entityType: props.childEntityType,
        entityId: props.itemId,
      })}
      onClick={event => {
        if (empty) event.preventDefault()
      }}
    >
      <div className={`ListItem ${empty ? "empty" : ""}`}>
        <div className="compliance-container">
          <div className="text-extrasmall semi-bold text-gray">
            {props.label}
          </div>
          <div className="compliance text-extrasmall semi-bold text-gray">
            {empty ? "" : props.compliance}%
          </div>
          <Progress
            className={complianceAmount(props.compliance)}
            percentage={props.compliance}
          />
        </div>
      </div>
    </Link>
  )
}

ListItem.propTypes = {
  index: PropTypes.number.isRequired,
  label: PropTypes.string,
  compliance: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  entityType: PropTypes.oneOf(["facility", "department"]).isRequired,
  entityId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  childEntityType: PropTypes.string.isRequired,
}

export default ListItem
